import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Card, CardContent, CardActionArea, Grid } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ALL_ARTICLES = [
  {
    slug: '/blog/t4-explicado-espanol-impuestos-canada',
    title: 'T4 explicado en español',
    desc: 'Aprende a leer tu T4, casillas clave y qué hacer si tienes varios.',
    color: '#1E3A5F',
  },
  {
    slug: '/blog/solidarity-tax-credit-quebec-guia-completa',
    title: 'Solidarity Tax Credit Quebec',
    desc: 'Crédito fiscal que muchos latinos pierden. Requisitos y cómo reclamarlo.',
    color: '#7D5A00',
  },
  {
    slug: '/blog/rrsp-deadline-marzo-2026',
    title: 'RRSP deadline: 3 de marzo',
    desc: '5 pasos para contribuir a tu RRSP antes de la fecha límite 2026.',
    color: '#1E3A5F',
  },
  {
    slug: '/blog/cra-vs-revenu-quebec-diferencias',
    title: 'CRA vs Revenu Quebec',
    desc: 'En Quebec declaras dos veces. Aprende las diferencias clave.',
    color: '#6A1B9A',
  },
];

const ArticulosRelacionadosQuebec = ({ exclude }) => {
  const articles = ALL_ARTICLES.filter((a) => a.slug !== exclude);

  return (
    <Box sx={{ my: 5 }}>
      <Typography variant="h4" sx={{ color: '#1A1A1A', mb: 2.5 }}>
        Artículos relacionados
      </Typography>
      <Grid container spacing={2}>
        {articles.map((a) => (
          <Grid item xs={12} sm={4} key={a.slug}>
            <Card
              sx={{
                height: '100%',
                borderTop: `3px solid ${a.color}`,
                borderRadius: '10px',
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.12)' },
              }}
            >
              <CardActionArea
                component={RouterLink}
                to={a.slug}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1A1A1A', mb: 0.5 }}>
                    {a.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#5F6B7A', lineHeight: 1.5 }}>
                    {a.desc}
                  </Typography>
                </CardContent>
                <Box sx={{ px: 2, pb: 2, display: 'flex', alignItems: 'center', gap: 0.5, color: a.color }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>Leer más</Typography>
                  <ArrowForwardIcon sx={{ fontSize: 16 }} />
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ArticulosRelacionadosQuebec;
